'use client';

/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';
import YouTube from 'react-youtube';

/* Internal Imports */
/* Components */
import { getEmbedUrl } from '@app-ps/Components/Utility/utils';

/* Services */
/* Styles */
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

/**
 * @param sectionContent
 * @param {object} sectionContent - Data for Section
 * @param margin
 * @param width
 * @param pxBase
 * @returns {ReactElement} MediaEmbed component
 */

const SliderEmbed = ({ sectionContent, margin, ...props }) => {
  // const [vidVis, setVidVis] = useState(false);
  const [opts, setOpts] = useState({});

  useEffect(() => {
    setOpts({
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay: 1,
      },
    });
  }, [global?.window]);

  const onReady = event => {
    event.target.playVideo();
  };

  return (
    <Box maxW="100%" w="full" height="100%" id="slide-vid" {...props}>
      <YouTube
        videoId={getEmbedUrl(sectionContent?.embedUrl)}
        onClick={onReady}
        // onReady={onReady}
        opts={opts}
        loading="lazy"
      />
      <style>
        {`
          #slide-vid iframe{
          height:100% !important;
          }
           #slide-vid > div{
          height:100% !important;
          }
          `}
      </style>
    </Box>
  );
};
export default SliderEmbed;

{
  /* <Box
// backgroundImage={sectionContent?.image?.url}
// backgroundSize="cover"
// backgroundColor="#000"
// backgroundRepeat="no-repeat"
// backgroundPosition="center"
// width="100%"
// position="relative"
// display="flex"
// justifyContent="center"
// alignItems="center"
// flexDir="column"
// cursor="pointer"
// onClick={e => setVidVis(!vidVis)}
// overflow="hidden"
// height={props.height}
// m={margin || '0 auto 30px auto'}
// id="msr-vid"
// {...props}
>
{vidVis && (
  <Box maxW="100%" w="full">
    <YouTube
      videoId={getEmbedUrl(sectionContent?.embedUrl)}
      onReady={onReady}
      opts={opts}
      loading="lazy"
    />{' '}
  </Box>
)}
</Box> */
}
